/*
Read More Modal
*/

const container = document.querySelector('.leadership-bio');

if (container) {
    const triggers = container.querySelectorAll('.read-more-modal');

    triggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            removeExistingModal(); // Remove any existing modals first
            createModal( this.closest('.leadership-bio-data') );
        });
    });
}

function removeExistingModal() {
    const existingModal = document.querySelector('.modal-overlay');
    if (existingModal) {
        document.body.removeChild(existingModal);
    }
}

function createModal( leaderData ) {
    document.body.classList.add('overflow-hidden');

    // Create the modal overlay
    const modalOverlay = document.createElement('div');
    modalOverlay.classList.add('modal-overlay');

    // Create the modal content
    const modalContent = document.createElement('div');
    modalContent.classList.add('modal-content');

    // Create the close button
    const closeButton = document.createElement('button');
    closeButton.classList.add('close-button');
    closeButton.innerHTML = `
        <svg viewBox="0 0 25 25" aria-hidden="true" class="w-full h-full fill-current">
            <title>Plus</title>
            <use xlink:href="#plus"></use>
        </svg>
    `;

    // Fetch the Image
    const bioImage = leaderData.querySelector('figure');

    // Fetch the Header
    const bioHeader = leaderData.querySelector('.bio-headline');

    // Fetch the Header
    const bioFull = leaderData.querySelector('.full-bio');

    // Clone the bioFull node
    const bioFullClone = bioFull ? bioFull.cloneNode(true) : null;

     // Remove the sr-only class from the cloned node
    if (bioFullClone) {
        bioFullClone.classList.remove('sr-only');
    }

    // Append the fetched elements to the modal content
    if (bioImage) modalContent.appendChild(bioImage.cloneNode(true));
    if (bioHeader) modalContent.appendChild(bioHeader.cloneNode(true));
    if (bioFullClone) modalContent.appendChild( bioFullClone.cloneNode(true) );

    // Append the close button to the modal content
    modalContent.appendChild(closeButton);

    // Append the modal content to the overlay
    modalOverlay.appendChild(modalContent);

    // Append the modal overlay to the body
    document.body.appendChild(modalOverlay);

    // Add event listener to close the modal
    closeButton.addEventListener('click', () => {
         // Remove overflow-hidden class from the body
        document.body.classList.remove('overflow-hidden');

        document.body.removeChild(modalOverlay);
    });
}